import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { ConfirmDialogComponent, ConfirmModel } from '../confirm-dialog/confirm-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { FeathericonsModule } from '../../../icons/feathericons/feathericons.module';
import { CustomErrorstatematcherComponent } from '../../../ui-elements/input/custom-errorstatematcher/custom-errorstatematcher.component';
import { MatCardModule } from '@angular/material/card';
import { gtpRutValidator } from '../../validators/gtp-rut-validator';

@Component({
  selector: 'app-create-company-dialog',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    CustomErrorstatematcherComponent, 
    ReactiveFormsModule, 
    FeathericonsModule,
    MatCardModule,
    ReactiveFormsModule,
    CommonModule
  ],
  templateUrl: './create-company-dialog.component.html',
  styleUrl: './create-company-dialog.component.scss'
})
export class CreateCompanyDialogComponent implements OnInit {

  nameControl: FormControl = new FormControl('', [Validators.required]);
  rutControl: FormControl = new FormControl('', [Validators.required, gtpRutValidator()]);
  descriptionControl: FormControl = new FormControl('', [Validators.required]);
  displayNameControl: FormControl = new FormControl('', [Validators.required]);
  onboardingForm: FormGroup = this.formBuilder.group({
    rut: this.rutControl,
    sii: this.nameControl,
    description: this.descriptionControl,
    displayName: this.displayNameControl
  });
  
  constructor(
    public dialogRef: MatDialogRef<CreateCompanyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmModel,
    private formBuilder: FormBuilder,
  ) {
  }

  ngOnInit() {

  }

  onNoClick() {
    this.dialogRef.close()
  }

  restrictSpecialChars(event: KeyboardEvent): void {
    const allowedChars = /^[a-zA-Z]+$/;
    if (!allowedChars.test(event.key)) {
      event.preventDefault();
    }
  }

  restrictSpecialCharsPaste(event: ClipboardEvent): void {
    event.preventDefault();
  }

  onCreate() {
    const id: string = this.nameControl.value
    const rut: string = this.rutControl.value
    const description: string = this.descriptionControl.value
    const displayName: string = this.displayNameControl.value

    this.dialogRef.close({ id, rut, description, displayName})
  }
}
